import { Button, Form, Modal, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { aboutUsEnumsArr, aboutUSkeys, contactEnumsArr, contactUSkeys, TAB_KEYS } from "../../../config";
import { useSettings } from "../../../custom-hooks/useSettings";
import { useTab } from "../../../custom-hooks/useTab";
import { useStore } from "../../../store";
import { setProSettingsData, setUpdatedValues } from "../../../store/actions";
import { formatData } from "../../../utils/formatData";
import { getValue } from "../../../utils/helper";
import "./index.scss";
import useTabsList from "./useTabsList";
import {
  CONTRACTS,
  CUSTOMER_SERVICES,
  VOLUNTEERING,
} from "../../../utils/constants";

function EditMicrosite({ micrositeId, newProSettings }) {
  const navigate = useNavigate();
  const { state } = useLocation();

  const { tabData } = useStore();

  const [form] = Form.useForm();

  const {
    getSingleTabData,
    dataLoader,
    callMicroServices,
    postLoader,
    getOptions,
  } = useTab();

  const { updatedValues, dispatch, settings } = useStore();
  const { getSettings } = useSettings();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [nextTabKey, setNextTabKey] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const [activeKey, setActiveKey] = useState("");
  const [formChanged, setFormChanged] = useState(false);
  // const [selectedActiveKey, setSelectedActiveKey] = useState(() => {
  //   localStorage?.getItem("selectedTabId");
  // });
  const [selectedActiveKey, setSelectedActiveKey] = useState(undefined);
  const [tabConfigId, setTabConfigId] = useState("");

  const { proSettingsObject, ProSettingsTabList } = useTabsList(newProSettings);

  const [splitParams, setSplitParams] = useState([]);
  const [tabId, setTabId] = useState("");
  const [tabIdLength, setTabIdLength] = useState(0);
  const [tabListArray, setTabListArray] = useState([]);

  const SubmitButton = ({ postLoader }) => {
    const getTabId = tabIdLength <= 1 ? tabId : splitParams[1];
    if (getTabId !== "work-experience" && getTabId !== "contract") {
      return (
        <div>
          {postLoader === true ? (
            <div>
              <Button className="saveBtn greenBtn">loading...</Button>
            </div>
          ) : formChanged ? (
            <Button
              className="saveBtn greenBtn"
              // htmlType="submit"
              onClick={() => {
                form.submit();
              }}
            >
              Save All
            </Button>
          ) : (
            <Button
              className="saveBtn greenBtn"
              style={{ opacity: "0.5", pointerEvents: "none" }}
            >
              Save All
            </Button>
          )}
        </div>
      );
    } else if (getTabId === "contract") {
      return (
        <div>
          {postLoader === true ? (
            <div>
              <Button className="saveBtn greenBtn">loading...</Button>
            </div>
          ) : formChanged ? (
            <Button
              className="saveBtn greenBtn"
              // htmlType="submit"
              onClick={() => {
                submit(form.getFieldValue());
              }}
            >
              Save All
            </Button>
          ) : (
            <Button
              className="saveBtn greenBtn"
              style={{ opacity: "0.5", pointerEvents: "none" }}
            >
              Save All
            </Button>
          )}
        </div>
      );
    } else {
      return <div></div>;
    }
    // return (
    //   <div>
    //     {postLoader === true ? (
    //       <div>
    //         <Button className="saveBtn greenBtn">loading...</Button>
    //       </div>
    //     ) : (
    //       <Button className="saveBtn greenBtn" htmlType="submit">
    //         Save
    //       </Button>
    //     )}
    //   </div>
    // );
  };

  // Function to check if there are unsaved changes
  const checkUnsavedChanges = (currentTabKey) => {
    const values = form.getFieldsValue();
    const valuesTabKey = Object.keys(values)[0];

    // If no form values, no changes
    if (!valuesTabKey || !values[valuesTabKey]) {
      return false;
    }

    const formData = values[valuesTabKey] || [];
    const beData = tabData[valuesTabKey] || [];

    // Check for new items (items without ID)
    const hasNewItems = formData.some((item) => !item.id);

    // Check for modified existing items
    const hasModifiedItems = formData.some((formItem) => {
      if (!formItem.id) return false; // Skip new items for modification check

      const beItem = beData.find((item) => item.id === formItem.id) || {};
      return Object.keys(formItem)
        .filter((key) => key !== "id" && key !== "title") // Ignore 'id' and 'title'
        .some((key) => {
          const beValue =
            beItem.aboutUsTeamDataOutPut && key in beItem.aboutUsTeamDataOutPut
              ? beItem.aboutUsTeamDataOutPut[key]
              : beItem[key];
          return (formItem[key] || "") !== (beValue || "");
        });
    });

    // For FULL_TIME and PART_TIME tabs, only check for new items, not modifications
    if (
      valuesTabKey === "FULL_TIME" ||
      valuesTabKey === "PART_TIME" ||
      valuesTabKey === "OUR_CLIENT" ||
      valuesTabKey === "OUR_STORY" ||
      valuesTabKey === "OUR_TEAM" ||
      valuesTabKey === "ACCREDITATIONS_AWARDS" ||
      valuesTabKey === "ADDRESS" ||
      valuesTabKey === "SOCIAL_MEDIA" ||
      valuesTabKey === "EXPERIENCES_OF_WORK" ||
      valuesTabKey === "SALES" ||
      valuesTabKey === "HUMAN_RESOURCE" ||
      valuesTabKey === "ABOUT_US" ||
      valuesTabKey === "contract"
    ) {
      return hasNewItems;
    }

    return hasNewItems || hasModifiedItems;
  };

  const handleTabs = async (tabKey) => {
    const previousTabKey = activeKey;

    // Don't show modal if clicking the same tab
    if (tabKey === activeKey) {
      return;
    }

    // Check if there are unsaved changes in current tab
    const unsavedChanges = checkUnsavedChanges(activeKey);

    if (unsavedChanges) {
      // Show modal and store the target tab
      setIsModalOpen(true);
      setNextTabKey(tabKey);
      setHasUnsavedChanges(true);
    } else {
      // No unsaved changes, proceed with tab change
      await changeTab(tabKey);
    }
  };

  const changeTab = async (tabKey) => {
    const selectedTab = tabListArray?.find((tab) => tab.tabKey === tabKey);

    if (selectedTab) {
      localStorage?.setItem("selectedTabId", selectedTab?.id);
      setSelectedActiveKey(selectedTab?.id);
      stateUpdateHandler(tabKey,micrositeId)
      setTabConfigId(selectedTab.id);
      localStorage?.setItem("storeCurrentTabKey", tabKey);
    }

    const selectId = await getValue("selectedTabId");
    callNavigation(tabKey, selectedTab?.id || selectedActiveKey);

    let TabKey = tabKey;
    if (
      tabKey === "SALES" ||
      tabKey === "HUMAN_RESOURCE" ||
      tabKey === "SOCIAL_MEDIA" ||
      tabKey === "EXPERIENCES_OF_WORK" ||
      tabKey === "REVIEWS" ||
      tabKey === "ADDRESS" ||
      tabKey === CUSTOMER_SERVICES ||
      tabKey === CONTRACTS ||
      tabKey === VOLUNTEERING
    ) {
      TabKey = "contact-us";
    }

    if (
      tabKey === "ABOUT_US" ||
      tabKey === "OUR_STORY" ||
      tabKey === "OUR_TEAM" ||
      tabKey === "OUR_CLIENT" ||
      tabKey === "ACCREDITATIONS_AWARDS"
    ) {
      TabKey = "about-us";
    }

    if (TabKey === "about-us" && !splitParams[0]) {
      navigate(`/${micrositeId}`, {
        state: `about-us/${aboutUSkeys.About}`,
      });
      return;
    } else {
      setActiveKey(TabKey);
    }

    // Reset states
    setHasUnsavedChanges(false);
    setNextTabKey(null);
  };

  // Handle Save button - save data then move
  const handleSave = async () => {
    try {
      // Submit the form to save data
      await form.submit();

      // Wait for save to complete (you might need to adjust this based on your save implementation)
      setTimeout(() => {
        setIsModalOpen(false);
        if (nextTabKey) {
          changeTab(nextTabKey);
        }
      }, 1000); // Adjust timeout as needed based on your save operation
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  // Handle Move without save
  const handleMoveWithoutSave = () => {
    setIsModalOpen(false);
    if (nextTabKey) {
      changeTab(nextTabKey);
    }
  };

  // Handle Cancel - stay on current tab
  const handleCancel = () => {
    setIsModalOpen(false);
    setNextTabKey(null);
    setHasUnsavedChanges(false);
  };

  const callNavigation = async (key, id) => {
    const selectId = await getValue("selectedTabId");
    if (contactEnumsArr.includes(key)) {
      navigate(`/${micrositeId}`, {
        state: `contact-us/${key}`,
      });
    } else if (aboutUsEnumsArr.includes(key)) {
      navigate(`/${micrositeId}`, {
        state: `about-us/${key}`,
      });
    } else if (key === TAB_KEYS.contactUs) {
      navigate(`/${micrositeId}`, {
        state: `${key + "/" + contactUSkeys.sales}`,
      });
    } else if (key === TAB_KEYS.aboutUs) {
      navigate(`/${micrositeId}`, {
        state: `${key + "/" + aboutUSkeys.About}`,
      });
    } else {
      navigate(`/${micrositeId}`, { state: `${key}` });
    }
    // id &&
    //   getSingleTabData(
    //     key === TAB_KEYS.contactUs
    //       ? contactUSkeys.sales
    //       : TAB_KEYS.aboutUs
    //         ? aboutUSkeys.About
    //         : key,
    //     form,
    //     id,
    //   );
  };

  const submit = (info) => {
    let selectedTab = tabListArray.find((tab) => tab.tabKey == activeKey);
    localStorage?.setItem("selectedTabId", selectedTab?.id);
    setSelectedActiveKey(selectedTab?.id);
    let getTabId = tabIdLength <= 1 ? tabId : splitParams[1];
    getTabId = getTabId === "about-us" ? "ABOUT_US" : getTabId;
    const formattedData = formatData(
      getTabId,
      info[getTabId],
      updatedValues,
      selectedTab?.id
    );
    if (Object.keys(formattedData).length > 0) {
      dispatch(setUpdatedValues({}));
      callMicroServices(getTabId, formattedData, form, selectedTab?.id);
    } else if (getTabId === "work-experience") {
      toast.success("Data updated successfully");
    } else {
      toast.error("Nothing to update");
    }
  };

  const fieldsChange = (fields) => {
    if (fields && fields.length === 1) {
      const getNames = fields[0].name;
      const nameModified =
        getNames[0] === "aboutUs"
          ? "about-us"
          : getNames[0] === "workExperience"
            ? "work-experience"
            : getNames[0];
      var prev = updatedValues;

      const prevItems = prev[nameModified];
      if (prevItems) {
        const names = [...prevItems, getNames[1]];
        const removeDuplicates = names.filter(function (
          item,
          index,
          inputArray
        ) {
          return inputArray.indexOf(item) == index;
        });
        prev[nameModified] = removeDuplicates;
      } else {
        prev[nameModified] = [getNames[1]];
      }

      // if(getAllField && getAllField.length > 0){
      //   const updatedFields = getAllField.map(name => ({ name, errors: [], ...name }));

      // // form.resetFields();

      // // form.setFields({fields : updatedFields});
      // }
      dispatch(setUpdatedValues(prev));
    }
  };

  const handleOk = () => {
    setUpdatedValues(null);
    callNavigation(nextTabKey);
    setActiveKey(
      contactEnumsArr.includes(nextTabKey)
        ? "contact-us"
        : aboutUsEnumsArr.includes(nextTabKey)
          ? "about-us"
          : nextTabKey
    );
    setIsModalOpen(false);
  };

  const onClickArrow = (direction) => {
    // const modifiedTabLists = tabList.filter(
    const modifiedTabLists = tabListArray?.filter(
      (d) =>
        !(d.settingsKey in settings) ||
        (d.settingsKey in settings && settings[d.settingsKey] !== false)
    );
    const getIndex = modifiedTabLists.findIndex((d) => d.tabKey == activeKey);

    if (getIndex !== -1) {
      if (direction === "right" && modifiedTabLists[getIndex + 1].tabKey) {
        handleTabs(modifiedTabLists[getIndex + 1].tabKey);
      } else if (
        direction === "left" &&
        modifiedTabLists[getIndex - 1].tabKey
      ) {
        handleTabs(modifiedTabLists[getIndex - 1].tabKey);
      }
    }
  };

  useEffect(() => {
    if (tabId && tabId != " ") {
      if (tabIdLength === 1 && splitParams[0] === TAB_KEYS.contactUs) {
        navigate(`/${micrositeId}`, {
          state: `${splitParams[0]}/${contactUSkeys.sales}`,
        });
      } else if (tabIdLength === 1 && splitParams[0] === TAB_KEYS.aboutUs) {
        navigate(`/${micrositeId}`, {
          state: `${splitParams[0]}/${aboutUSkeys.About}`,
        });
      } else {
        navigate(`/${micrositeId}`, { state: tabId });
      }
    } else {
      navigate(`/${micrositeId}`, { state: `${TAB_KEYS.aboutUs}` });
    }
    getSettings(micrositeId);
  }, [micrositeId, tabId, tabIdLength, splitParams]);

  useEffect(() => {
    if(selectedActiveKey){
      localStorage?.setItem("selectedTabId", selectedActiveKey);
    }
    else{
      localStorage?.removeItem("selectedTabId");
    }
    if (selectedActiveKey && tabId && tabId != "") {
      if (
        splitParams[1] !== CONTRACTS &&
        splitParams[1] !== VOLUNTEERING &&
        splitParams[1] !== CUSTOMER_SERVICES
      ) {
        getSingleTabData(
          tabIdLength <= 1 ? tabId : splitParams[1],
          form,
          selectedActiveKey,
        );
      }
    }
  }, [tabIdLength, tabId, tabListArray, selectedActiveKey, splitParams]);

  useEffect(() => {
    if (micrositeId && proSettingsObject) {
      // if proSetting is disabled masterData key will not be there prevent api call
      if (proSettingsObject?.["35499238-0937-11f0-b61c-6045bd0fa337"]?.id)
        getOptions(
          micrositeId,
          "PRODUCT",
          proSettingsObject?.["35499238-0937-11f0-b61c-6045bd0fa337"]?.id
        );
      if (proSettingsObject?.["35499b63-0937-11f0-b61c-6045bd0fa337"]?.id)
        getOptions(
          micrositeId,
          "COURSES",
          proSettingsObject?.["35499b63-0937-11f0-b61c-6045bd0fa337"]?.id
        );
      if (proSettingsObject?.["35499ab7-0937-11f0-b61c-6045bd0fa337"]?.id)
        getOptions(
          micrositeId,
          "TEAMS_AND_ROLES",
          proSettingsObject?.["35499ab7-0937-11f0-b61c-6045bd0fa337"]?.id
        );
    }
  }, [micrositeId, proSettingsObject]);


  const stateUpdateHandler = (state,micrositeId)=>{
    if (state === "about-us") {
      navigate(`/${micrositeId}`, {
        state: `about-us/${aboutUSkeys.About}`,
      });
    }
    if (state.length > 0) {
      const tabId = state;
      setTabId(state);

      const tempSplitParams = tabId
        ? tabId?.split("/").filter(function (entry) {
          return entry.trim() != "";
        })
        : [];
      setSplitParams(tempSplitParams);

      setTabIdLength(tempSplitParams.length);
    } else {
      navigate(`/${micrositeId}`, {
        state: `about-us/${aboutUSkeys.About}`,
      });
    }
  }
  useEffect(() => {
    stateUpdateHandler(state,micrositeId)
  }, [state,micrositeId]);

  useEffect(() => {
    const isNotEmpty = Object.keys(updatedValues).length > 0;

    setFormChanged(isNotEmpty);
  }, [Object.keys(updatedValues).length]);


  window.addEventListener("beforeunload", () => {
    localStorage.removeItem("storeCurrentTabKey");
  });

  useEffect(() => {
    let tabActiveKey = tabIdLength <= 1 ? tabId : splitParams[0];
    let selectedTab = tabListArray.find((tab) => tab.tabKey === tabActiveKey);
    if (selectedTab) {
      setActiveKey(selectedTab?.tabKey);
    }

    if (!settings[selectedTab?.settingsKey]) {
      setTimeout(() => {
        handleTabs(localStorage?.getItem("storeCurrentTabKey") || "about-us");
      }, 500);
    }
  }, [
    settings?.businessCard,
    settings?.apprenticeships,
    settings?.experienceOfWork,
    settings?.teamsAndRoles,
    settings?.products,
    settings?.services,
    settings?.contracts,
    settings?.vacancies,
    settings?.whyWork,
    tabListArray,
  ]);

  useEffect(() => {
    let selectedTab = tabListArray.find((tab) => tab.tabKey == activeKey);
    let carouselId = tabListArray.find(
      (tab) => (tab.displayName == "Home carousel" || tab.oldName == "Home carousel")
    )?.id;
    // localStorage?.setItem("selectedTabId", selectedTab?.id);
    localStorage?.setItem("carouselId", carouselId);

    setSelectedActiveKey(selectedTab?.id);
  }, [tabListArray]);

  useEffect(() => {
    setTabListArray(ProSettingsTabList);
    dispatch(setProSettingsData({ proSettingData: ProSettingsTabList }));
  }, [ProSettingsTabList]);

  const currentIndex = tabListArray.findIndex(
    (tab) => tab.tabKey === activeKey
  );
  return (
    <React.Fragment>
      {activeKey ? (
        <div className="tabHeadContainer">
          <Form
            form={form}
            autoComplete="off"
            // name={TAB_KEYS.corousel}
            name='microsite-form'
            onFinish={(values) => {
              submit(values);
            }}
            onFieldsChange={fieldsChange}
          >
            <Tabs
              type="card"
              className="tabBodyContainer"
              onChange={handleTabs}
              activeKey={activeKey}
              destroyInactiveTabPane={false}
              tabBarExtraContent={
                <div style={{ display: "flex", alignContent: "center" }}>
                  {/* Left / Prev Button */}
                  <div
                    className={`leftArrow ${currentIndex === 0 ? "disabled" : ""
                      }`}
                    onClick={() => currentIndex > 0 && onClickArrow("left")}
                    style={{
                      pointerEvents: currentIndex === 0 ? "none" : "auto",
                      opacity: currentIndex === 0 ? 0.4 : 1,
                    }}
                  >
                    <img
                      className="arrow-nav-btn"
                      src={require("../../../assets/images/Path3954.png")}
                      alt="prev"
                    />
                    <img
                      className="arrow-nav-btn"
                      src={require("../../../assets/images/Path3954.png")}
                      alt="prev"
                    />
                  </div>

                  {/* Right / Next Button */}
                  <div
                    className={`rightArrow ${currentIndex === tabListArray.length - 1 ? "disabled" : ""
                      }`}
                    onClick={() =>
                      currentIndex < tabListArray.length - 1 &&
                      onClickArrow("right")
                    }
                    style={{
                      pointerEvents:
                        currentIndex === tabListArray.length - 1
                          ? "none"
                          : "auto",
                      opacity:
                        currentIndex === tabListArray.length - 1 ? 0.4 : 1,
                    }}
                  >
                    <img
                      className="arrow-nav-btn"
                      src={require("../../../assets/images/Path3900.png")}
                      alt="next"
                    />
                    <img
                      className="arrow-nav-btn"
                      src={require("../../../assets/images/Path3900.png")}
                      alt="next"
                    />
                  </div>
                </div>
              }
            >
              {tabListArray?.map((tab) => (
                <Tabs.TabPane
                  className="contactUsContent"
                  tab={tab.displayName}
                  key={tab.tabKey}
                >
                  {activeKey === tab.tabKey &&
                    <div className="scrollable-tab-content">
                  {console.log('activeKey', activeKey, tab.tabKey)}

                      {tab.component({
                        dataLoader,
                        form,
                        handleTabs,
                        splitParams,
                        activeKey,
                        getSingleTabData,
                        tab,
                        tabHandleSaveClick: (form) => {
                          submit(form.getFieldValue())

                        },
                      })}
                    </div>}
                </Tabs.TabPane>
              ))}
            </Tabs>

            <div className="submit-section-bottom">
              <SubmitButton postLoader={postLoader} />
            </div>
          </Form>
          <Modal
            open={isModalOpen}
            onCancel={handleCancel}
            footer={[
              <Button
                key="save"
                type="primary"
                onClick={handleSave}
                className="saveAndMove"
              >
                Save and Move
              </Button>,
              <Button
                key="move"
                onClick={handleMoveWithoutSave}
                className="moveOnly"
              >
                Move
              </Button>,
              <Button key="cancel" onClick={handleCancel} className="cancelBtn">
                Cancel
              </Button>,
            ]}
          >
            <div className="tab-changes" style={{ padding: "40px 0 20px" }}>
              You have unsaved changes. Would you like to save before moving to
              the next tab?
            </div>
          </Modal>
        </div>
      ) : null}
    </React.Fragment>
  );
}

export default EditMicrosite;
